export default class LavoraConNoi {
    constructor(node) {
        this.node = node;
        this.formNodes = node.querySelectorAll('.posizione-aperta__form_candidatura');
        this.filtriNode = node.querySelector('.section--filtri');
        
        this.selectedFilters = {
            dipartimento: [],
            sede: []
        };
        
        this.settings = window.lavoraConNoiSettings;
        
        this.addListeners();
    }

    static init() {
        let LavoraConNoiNode = document.querySelector("[data-lavora-con-noi]");

        if (LavoraConNoiNode) {
            return new LavoraConNoi(LavoraConNoiNode);
        }
    }
    
    addListeners() {
        let _this = this;

        if (this.filtriNode) {
            this.filtriNode.querySelector('.filtri-scelti').addEventListener('click', function(event) {
                if (event.target.dataset.filter === undefined) {
                    return;
                }

                _this.toggleFilter(event.target);
                _this.filterListing();
            });   
        }
        
        this.formNodes.forEach(function(formNode) {
            $(formNode).validate({
                getDataToSend: function (form)
                {
                    return {
                        data: {
                            PosizioneApertaID: formNode.querySelector('[name="posizioneApertaID"]').value,
                            Nome: formNode.querySelector("input[name='nome']").value,
                            Cognome: formNode.querySelector("input[name='cognome']").value,
                            Email: formNode.querySelector("input[name='email']").value,
                            ProvinciaDesc: formNode.querySelector('input[name="provincia"]').value,
                            Nazione: formNode.querySelector("select[name='nazione']").options[formNode.querySelector("select[name='nazione']").selectedIndex].value,
                            Messaggio: formNode.querySelector("textarea[name='messaggio']").value,
                            Privacy: formNode.querySelector("input[name='privacy']").checked,
                            CurriculumFileBase64: formNode.CurriculumFileBase64,
                            CurriculumFilename: formNode.CurriculumFilename,
                            PortfolioFileBase64: formNode.PortfolioFileBase64,
                            PortfolioFilename: formNode.PortfolioFilename
                        }
                    };
                },
                callbackHandler: function (data, form)
                {
                    formNode.querySelector('.response-text').innerHTML = data.d.HTML;

                    formNode.querySelectorAll('input:not([type="submit"]), textarea').forEach(function(input) {
                        input.value = '';
                    });

                    $('html, body').animate({
                        scrollTop: $('.response-text').offset().top - 300
                    }, 500);

                    if (data.d.Status) {
                        formNode.querySelector('input[type="submit"]').style.display = 'none';
                    }
                }
            });
            
            // Read base64 file CV
            let cvFileNode = formNode.querySelector('input[name="cv_file"]');

            cvFileNode.addEventListener('change', function(event) {
                let fileReader = new FileReader();
                let file = cvFileNode.files[0];

                if (!_this.checkValidUpload(file)) {
                    formNode.querySelector('input[data-name-file="' + this.getAttribute('id') + '"]').value = "";
                    this.value = "";
                    
                    return;                    
                }
                    
                fileReader.readAsDataURL(file);
                fileReader.addEventListener("load", function () {
                    formNode.CurriculumFileBase64 = fileReader.result;
                    formNode.CurriculumFilename = file.name;
                });
            });

            // Read base64 file Portfolio
            let portfolioFileNode = formNode.querySelector('input[name="portfolio_file"]');

            portfolioFileNode.addEventListener('change', function(event) {
                let fileReader = new FileReader();
                let file = portfolioFileNode.files[0];

                if (!_this.checkValidUpload(file)) {
                    formNode.querySelector('input[data-name-file="' + this.getAttribute('id') + '"]').value = "";
                    this.value = "";
                    
                    return;
                }

                fileReader.readAsDataURL(file);
                fileReader.addEventListener("load", function () {
                    formNode.PortfolioFileBase64 = fileReader.result;
                    formNode.PortfolioFilename = file.name;
                });
            });
        });
    }
    
    checkValidUpload(file) {
        if (!this.settings.permittedUploadFiles.includes(file.type)) {
            alert(this.settings.labels.file_invalid_type);
            return false;
        }
        else if (file.size > this.settings.maxUploadSizeMb * 1024 * 1024) {
            alert(this.settings.labels.file_too_large);
            return false;
        }
        
        return true;
    }
    
    filterListing() {
        let _this = this;
        
        this.node.querySelectorAll('.mansione').forEach(function(mansioneNode) {
            let dipartimentoMansione = mansioneNode.dataset.dipartimento;
            
            if (dipartimentoMansione !== "" && _this.selectedFilters.dipartimento.length !== 0 && _this.selectedFilters.dipartimento.indexOf(dipartimentoMansione) < 0) {
                mansioneNode.style.display = "none";
            }
            else {
                mansioneNode.style.display = "block";
            }
        });

        this.node.querySelectorAll('.posizione-aperta').forEach(function(posizioneNode) {
            let sedePosizione = posizioneNode.dataset.sede;

            if (sedePosizione !== "" && _this.selectedFilters.sede.length !== 0 && _this.selectedFilters.sede.indexOf(sedePosizione) < 0) {
                posizioneNode.style.display = "none";
            }
            else {
                posizioneNode.style.display = "block";
            }
        });
    }

    toggleFilter(filterNode) {
        let _this = this;
        let filterID = filterNode.dataset.filter;
        let filterType = filterNode.dataset.filterType;
        let addFilter = true;
        
        if (filterID === "all") {
            // "Rimuovi tutti i filtri"
            _this.selectedFilters = {
                dipartimento: [],
                sede: []
            };
            
            return;
        }

        Object.keys(this.selectedFilters).forEach(function(key,i) {
            let index = _this.selectedFilters[key].indexOf(filterID);
            
            if (index > -1) {
                _this.selectedFilters[key].splice(index, 1);
                addFilter = false;
            }
        });

        if (addFilter){
            this.selectedFilters[filterType].push(filterID);
        }
    }
    
    submitCandidaturaForm(formNode) {
        let _this = this;
        let responseData = {};

        let submittedData = {
            data: {
                PosizioneApertaID: formNode.querySelector('[name="posizioneApertaID"]').value,
                Nome: formNode.querySelector("input[name='nome']").value,
                Cognome: formNode.querySelector("input[name='cognome']").value,
                Email: formNode.querySelector("input[name='email']").value,
                ProvinciaDesc: formNode.querySelector('input[name="provincia"]').value,
                Nazione: formNode.querySelector("select[name='nazione']").options[formNode.querySelector("select[name='nazione']").selectedIndex].value,
                Messaggio: formNode.querySelector("textarea[name='messaggio']").value,
                Privacy: formNode.querySelector("input[name='privacy']").checked,
                CurriculumFileBase64: formNode.CurriculumFileBase64,
                CurriculumFilename: formNode.CurriculumFilename,
                PortfolioFileBase64: formNode.PortfolioFileBase64,
                PortfolioFilename: formNode.PortfolioFilename
            }
        };
        
        formNode.classList.add('busy');

        formNode.querySelector('.response-text').innerHTML = "";

        $.ajax({
            type: "POST",
            url: formNode.getAttribute('action'),
            cache: false,
            contentType: "application/json; charset=utf-8",
            data: JSON.stringify(submittedData),
            dataType: "json",
            success: function (data) {
                responseData = data;

                if (responseData.d.Status === true) {
                    formNode.querySelector('.response-text').innerHTML = responseData.d.HTML;

                    formNode.querySelectorAll('input:not([type="submit"]), textarea').forEach(function(input) {
                        input.value = '';
                    });
                }
                else {
                    formNode.querySelector('.response-text').innerHTML = _this.settings.labels.form_error;

                    console.log("response error: ");
                    console.log(responseData.d.ErrMessage);
                }
            },
            error: function (data) {
                responseData = data;
                
                formNode.querySelector('.response-text').innerHTML = _this.settings.labels.form_error;
                
                console.log("response error: ");
                console.log(responseData);
            },
            complete: function() {
                formNode.classList.remove('busy');

                $('html, body').animate({
                    scrollTop: $('.response-text').offset().top - 100
                }, 500);                
            }
        });
    }
}